import { Tag } from "./Tag";
import { toMap, lazyloadImage } from "../../../HA";

// ha/441b stub: HtmlService.uuidv4 → port dans grappe HTML.Service (grappes suivantes)
const HtmlServiceStub: any = {
    uuidv4: (): string => typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
        ? crypto.randomUUID()
        : Math.random().toString(36).slice(2, 11),
};

export class Img extends Tag {

    // Un Img est toujours un <img>. Sans cet override, getTagName() hérite du
    // défaut Tag ("div") quand `_tn` n'est pas posé (cas où le converter met
    // src/alt en attributs HTML plutôt qu'en clés) → l'image rendait un <div>
    // vide (régression de conversion ha/441).
    public getTagName(): string {
        return "img";
    }

    public updateSrc(src: string): void {
        this.addToData("src", src);
        this.addAttribute("src", src);
    }

    protected initialize(data: any) {
        if (typeof data === "string") {
            data = toMap({ src: data });
        }
        if (data.get("src")) {
            data.set("src", this.translate(data.get("src")));
            data.set("_tn", "img");
            super.initialize(data);
            this.addAttribute("data-id", HtmlServiceStub.uuidv4());

            this.addAttribute("alt", this.translate(this.get("alt")) || "Image");
            if (this.get("h")) {
                this.addAttribute("height", this.get("h"));
            }
            if (this.get("w")) {
                this.addAttribute("width", this.get("w"));
            }
            if (this.has("load")) {
                this.addAttribute("src", this.get("src"));
            } else {
                this.addAttribute("data-src", this.get("src"));
                this.addAttribute("loading", "lazy");
                lazyloadImage(this.getElement() as HTMLImageElement);
            }
        } else if (data.get("f")) {
            const file = data.get("f");
            super.initialize(Tag.createElement("img"));
            const reader = new FileReader();
            reader.onload = (_e: ProgressEvent) => {
                this.setAttribute("src", reader.result as string);
            };
            reader.readAsDataURL(file);
        } else {
            super.initialize(data);
        }
    }
}
